(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-interactive"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.bfi__grid').forEach(function (grid) {
    if (grid.dataset.bfiBound) return;
    grid.dataset.bfiBound = 'true';
    var cards = grid.querySelectorAll('.bfi__card');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });
    cards.forEach(function (c) { observer.observe(c); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-interactive"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rows = document.querySelectorAll('.anchor-compare__row');
  if (!rows.length) return;
  if (!('IntersectionObserver' in window)) {
    rows.forEach(function (row) { row.classList.add('is-visible'); });
    return;
  }
  var rowList = Array.prototype.slice.call(rows);
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = (rowList.indexOf(entry.target) % 4) * 80;
        setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });
  rowList.forEach(function (row) { observer.observe(row); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee-panel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.gtp__badge').forEach(function (badge) {
    if (badge.dataset.gtpBound) return;
    badge.dataset.gtpBound = 'true';
    if (!('IntersectionObserver' in window)) {
      badge.classList.add('is-visible');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    observer.observe(badge);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-interactive"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hiw__steps').forEach(function (stepsWrap) {
    if (stepsWrap.dataset.hiwBound) return;
    stepsWrap.dataset.hiwBound = 'true';
    var steps = stepsWrap.querySelectorAll('.hiw__step');
    if (!steps.length) return;
    if (!('IntersectionObserver' in window)) {
      stepsWrap.classList.add('is-visible');
      steps.forEach(function (s) { s.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stepsWrap.classList.add('is-visible');
          steps.forEach(function (s) { s.classList.add('is-visible'); });
          obs.disconnect();
        }
      });
    }, { threshold: 0.25 });
    observer.observe(stepsWrap);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-panel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.spl__grid').forEach(function (grid) {
    if (grid.dataset.splBound) return;
    grid.dataset.splBound = 'true';
    var panels = grid.querySelectorAll('.spl__panel');
    if (!panels.length) return;
    if (!('IntersectionObserver' in window)) {
      panels.forEach(function (p) { p.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25 });
    panels.forEach(function (p) { observer.observe(p); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-interactive"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.tli__rows').forEach(function (rowsWrap) {
    if (rowsWrap.dataset.tliBound) return;
    rowsWrap.dataset.tliBound = 'true';
    var rows = rowsWrap.querySelectorAll('.tli__row');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) {
      rowsWrap.classList.add('is-visible');
      rows.forEach(function (r) { r.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          rowsWrap.classList.add('is-visible');
          rows.forEach(function (r) { r.classList.add('is-visible'); });
          obs.disconnect();
        }
      });
    }, { threshold: 0.2 });
    observer.observe(rowsWrap);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
